module.exports = __webpack_public_path__ + "img/ipad-composite-mobile_en.9382cca.jpg";